import type { Brand, BrandInput } from '@shop-monorepo/types';
import { useMutation, useQuery } from '@tanstack/react-query';
import { message } from 'antd';

import { apiClient } from '../services/api';

const BRAND_QUERY_KEY = ['brands'];

export const useBrands = (
  sorter?: { field?: string; direction?: 'asc' | 'desc' },
  filters?: { isActive?: boolean },
) => {
  return useQuery<Brand[], Error>({
    queryKey: [...BRAND_QUERY_KEY, sorter, filters],
    queryFn: async () => {
      const data = await apiClient.brands.all(sorter, filters);
      return data;
    },
  });
};

export const useCreateBrand = () => {
  return useMutation<Brand, Error, BrandInput>({
    mutationFn: (newBrand) => apiClient.brands.create(newBrand),
    meta: { invalidates: [BRAND_QUERY_KEY] },
    onSuccess: () => {
      message.success('Бренд успішно додано!');
    },
    onError: (error) => {
      message.error(`Не вдалося додати бренд: ${error.message}`);
    },
  });
};

export const useUpdateBrand = () => {
  return useMutation<Brand, Error, { id: number; brand: BrandInput }>({
    mutationFn: ({ id, brand }) => apiClient.brands.update(id, brand),
    meta: { invalidates: [BRAND_QUERY_KEY] },
    onSuccess: () => {
      message.success('Бренд успішно оновлено!');
    },
    onError: (error) => {
      message.error(`Не вдалося оновити бренд: ${error.message}`);
    },
  });
};

export const useDeleteBrand = () => {
  return useMutation<
    { message: string },
    Error,
    number // The id of the brand to delete
  >({
    mutationFn: (id) => apiClient.brands.delete(id),
    meta: { invalidates: [BRAND_QUERY_KEY] },
    onSuccess: () => {
      message.success('Бренд успішно видалено!');
    },
    onError: (error) => {
      message.error(`Не вдалося видалити бренд: ${error.message}`);
    },
  });
};
